export default {
  'sendverificationsms.sendverificationsms': 'ارسال پیام تاییدیه',
  'sendverificationsms.maintext':
    'با فشردن گزینه ارسال پیام، شما پیامی حاوی کد تاییدیه ثبت نام بر روی شماره ثبت نامی خود دریافت خواهید کرد',
  'sendverificationsms.sendsms': 'ارسال پیام',
};
